export const QuerySelector = (
  isExport,
  paginationData,
  searchQuery,
  bankID,
  branchID,
  role
) => {
  const baseParams = [`bank_id=${bankID}`];

  if (role === "admin") {
    baseParams.push(`branch_id=${branchID}`);
  }

  if (isExport) {
    baseParams.unshift("getAllData=true");
  } else {
    baseParams.unshift(`search=${searchQuery}`, `page=${paginationData}`);
  }

  return baseParams.join("&");
};

export const QuerySelector2 = (
  paginationData,
  searchQuery,
  bankID,
  branchID,
  role
) => {
  const baseParams = [`bank_id=${bankID}`];

  if (role === "admin") {
    baseParams.push(`branch_id=${branchID}`);
  }
  baseParams.unshift(`search=${searchQuery}`, `page=${paginationData}`);
  return baseParams.join("&");
};

export const QuerySelector3 = (
  paginationData,
  searchQuery,
  bankID,
  branchID,
  role
) => {
  const baseParams = [`bank=${bankID}`];

  if (role === "admin") {
    baseParams.push(`branch=${branchID}`);
  }
  baseParams.unshift(`search=${searchQuery}`, `page=${paginationData}`);
  return baseParams.join("&");
};
